<template>
  <div></div>
</template>

<script>

import IClassroom from '@/components/classroom/lib/IClassroom'

export default {
  props: ['message'],
  async mounted () {
    if (Array.isArray(this.message.data.text)) {
      for (const text of this.message.data.text) {
        this.$noty.show(text, this.message.data.type || 'info', { timeout: this.message.data.time || 3000 })
      }
    } else {
      this.$noty.show(this.message.data.text, this.message.data.type || 'info', { timeout: this.message.data.time || 3000 })
    }
    IClassroom.requestNextMessage()
  }
}
</script>
